import { arrify } from 'Global/Helpers/arrayHelpers'

export const hasPermission = (permissions, userPermissions = [], ignoreAdmin = false) => {
  const arrifiedPermissions = arrify(permissions)

  if (userPermissions.includes('general.isAdmin') && !ignoreAdmin) {
    return true
  }

  const filtered = arrifiedPermissions.filter(permissionKey => userPermissions.includes(permissionKey))

  if (filtered.length > 0) {
    return true
  }

  return false
}
